import baseModule from '@/store/shared/graphql'
import api from '@/api/exportLog/headers'

const STORE_TYPE = 'EXPORT_LOG_HEADERS'
const API_DATA_KEY = 'activityLogHeaders'
const API_DATA_BY_ID_KEY = 'batchId'
const defaultModule = baseModule(STORE_TYPE, API_DATA_BY_ID_KEY, API_DATA_KEY, api)

export default {
    state: {
        ...defaultModule.state,
    },
    getters: {
        ...defaultModule.getters,
    },
    mutations: {
        ...defaultModule.mutations,
    },
    actions: {
        ...defaultModule.actions,
    },
    namespaced: true,
}
